/**
 * TODO axios封装
 */
import axios from "axios";
// import qs from "qs";
import { Message } from "element-ui";
// import store from '@/store'
import router from '@/router';
import utils from "@/utils/utils";
// import { saveAs } from 'file-saver'

// create an axios instance
const service = axios.create({
	baseURL: utils.Url,
	withCredentials: true, // send cookies when cross-domain requests
	headers: {
		get: {
			"Content-Type": "application/x-www-form-urlencoded;charset=utf-8"
			// 在开发中，一般还需要单点登录或者其他功能的通用请求头，可以一并配置进来
		},
		post: {
			"Content-Type": "application/json;charset=utf-8"
			// 在开发中，一般还需要单点登录或者其他功能的通用请求头，可以一并配置进来
		}
	}
});

// 拦截器：在请求或响应被 then 或 catch 处理前拦截它们。
// request interceptor
service.interceptors.request.use(
	config => {
		// do something before request is sent
		// console.log(config.url.indexOf("geocoder"));
		// console.log(config)
		if (config.url.indexOf("captchaImage") != -1) {
			// console.log("获取验证码");
		} else if(config.url.indexOf("login") != -1) {
			// console.log("登录");
		} else if(config.url.indexOf("/customerCall/uploadFile") != -1){
			// console.log("上传文件");
		} else if(config.url.indexOf("getNickName") != -1){
			// console.log("获取用户昵称");
		} else if(config.url.indexOf("geocoder") != -1){
			// console.log("地理位置信息");
		} else if(config.url.indexOf("fuDeptList") != -1){

		} else{
			// console.log(config)
			// if (localStorage.getExpire("token")) {
			// 	config.headers["Authorization"] = localStorage.getExpire("token");
			// } else {
			// 	this.$router.push("/login");
			// }
			if (config.method === 'post') {
				// 如果是get请求，且params是数组类型如arr=[1,2]，则转换成arr=1&arr=2
				config.paramsSerializer = function(params) {
				//   return qs.stringify(params, { arrayFormat: 'repeat' })
				}
			}
			// config.headers.Authorization = localStorage.getExpire("token");
		}
		return config;
	},
	error => {
		// do something with request error
		console.log(error); // for debug
		return Promise.reject(error);
	}
);

// response interceptor
service.interceptors.response.use(
	/**
	 * If you want to get http information such as headers or status
	 * Please return  response => response
	 */
	response => {
		// 注意：return的是res对象
		const res = response.data;
		// console.log(res)
		// if(res.code == 401){
		// 	localStorage.clear('userInfo');
        //     localStorage.clear('token');
        //     localStorage.clear('roleGroup');
        //     localStorage.clear('postGroup');
		// 	router.replace({
        //         path: '/login'
        //         //登录成功后跳入浏览的当前页面
        //         // query: {redirect: router.currentRoute.fullPath}
        //     })
		// }else if(res.code == 500){
		// 	Message({
		// 		message: res.msg,
		// 		type: "error",
		// 	});
		// }
		// do something

		return res;
	},
	err => {
		console.log(err);
		Message({
			message: err.msg || "系统异常，请稍后操作",
			type: "error",
			duration: 5 * 1000
		});
		// router.replace({
		// 	path: '/login'
		// })
		return Promise.reject(err);
	}
);

export default service;



// WEBPACK FOOTER //
// ./src/utils/request.js